import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSpring, a } from '@react-spring/web';
import useMeasure from 'react-use-measure';
import { Container, Title, Frame, Content, Partner } from './styled';
import { SidebarSvgContainer } from '../container-sidebar/styled';
import { SidebarIcon } from '../view-sidebar/styled';
import { faHammer } from '@fortawesome/pro-solid-svg-icons';
import { useSelector } from 'react-redux';
import { isHemeaAvailableSelector, isCicAvailableSelector } from '../../selectors';
function usePrevious() {
  const ref = useRef();
  if (ref) ref.current;
}
const Tree = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    name,
    style,
    defaultOpen = false
  } = _ref;
  const [isOpen, setOpen] = useState(defaultOpen);
  const previous = usePrevious(isOpen);
  const [ref, {
    height: viewHeight
  }] = useMeasure();
  const {
    height,
    opacity,
    y
  } = useSpring({
    from: {
      height: 0,
      opacity: 0,
      y: 20
    },
    to: {
      height: isOpen ? viewHeight : 0,
      opacity: isOpen ? 1 : 0,
      y: isOpen ? 0 : 0
    }
  });
  return /*#__PURE__*/React.createElement(Frame, null, /*#__PURE__*/React.createElement(Title, {
    style: style,
    onClick: () => setOpen(!isOpen),
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement(SidebarSvgContainer, null, /*#__PURE__*/React.createElement(SidebarIcon, {
    size: "3x",
    icon: faHammer
  })), name), /*#__PURE__*/React.createElement(Content, {
    style: {
      opacity,
      height: isOpen && previous === isOpen ? 'auto' : height
    }
  }, /*#__PURE__*/React.createElement(a.div, {
    ref: ref,
    style: {
      y
    },
    children: children
  })));
});
export default function TreeList() {
  // const isHemeaAvailable = useSelector(isHemeaAvailableSelector)
  // const isCicAvailable = useSelector(isCicAvailableSelector)
  // const history = useHistory()
  // const handleSwitchPage = (event, path) => {
  //     event.preventDefault()
  //     history.push(path)
  // }

  return /*#__PURE__*/React.createElement(Container, null);
}